import * as commonScripts from '../common'

const cmpInsuranceSolutionsAumCharts = {
	component: null,
	
	init: function(element) {
		const _ = this
		_.component = element

		var eIAumByClientTypeDataList = []
		var eIAumByClientTypeDataLabelList = []
		var eIAumByAssetCategoryDataList = []
		var eIAumByAssetCategoryDataLabelList = []
		var eIAumByRegionDataList = []
		var eIAumByRegionDataLabelList = []
		// get all chart instances on the page
		const charts = document.querySelectorAll('.insurance-solutions-aum-chart');

		// add the colour pallette from the home page js file
		let chartColors = [];
		for (var j = 0; j < ChartColor.length; j++)
		{
			chartColors.push(ChartColor[j].colorcode);
		}
		
		// loop over all the canvases on the page which have a class of bpcc-chart
		async function DisplayChart() {
			await getInsuranceSolutionsAUMData(); 
			for(const chart of charts)
			{
				const dataValuesLabels = GetChartData(chart);
				const options = getChartOptions(chart);

				const context = chart.getContext('2d');
				context.height = 'auto';
				
				let config = {
					plugins:[ChartDataLabels], 
					type: dataValuesLabels.type,
					data: dataValuesLabels.data, 
					options: options 
				};

				new Chart(context, config);

				
			}
		}

		DisplayChart()

		// get data and other settings for each chart
		function GetChartData(chartInstance) 
		{         		
			if(chartInstance.id === 'external-insurance-aum-by-client-type-chart')
			{
				return {
					type: 'doughnut', 
					data: {
						labels: eIAumByClientTypeDataLabelList,
						datasets: [{
							backgroundColor: chartColors,
							borderColor: chartColors,
							borderWidth: 1,
							hoverBackgroundColor: chartColors,
							hoverBorderColor: chartColors,
							data: eIAumByClientTypeDataList
						}],
					},
				}
			}
			
			else if(chartInstance.id === 'external-insurance-aum-by-asset-category-chart')
			{
				return {
					type: 'doughnut', 
					data: {
						labels: eIAumByAssetCategoryDataLabelList,
						datasets: [{
							backgroundColor: chartColors,
							borderColor: chartColors,
							borderWidth: 1,
							hoverBackgroundColor: chartColors,
							hoverBorderColor: chartColors,
							data: eIAumByAssetCategoryDataList
						}],
					},
				}
			}

            else if(chartInstance.id === 'external-insurance-aum-by-region-chart')
			{
				return {
					type: 'doughnut', doughnutCoefficient:0.6,
					data: {
						labels: eIAumByRegionDataLabelList,
						datasets: [{
							backgroundColor: chartColors,
							borderColor: chartColors,
							borderWidth: 1,
							hoverBackgroundColor: chartColors,
							hoverBorderColor: chartColors,
							data: eIAumByRegionDataList
						}],
					},
				}
			}
        }

        async function getInsuranceSolutionsAUMData() {
			let lang = document.documentElement.lang;
			
			if(lang === null || lang.trim() === ""){
				lang = "en";
			}
			
			const response = await window.fetch("/api/insurance-solutions-aum-data/" + lang)
			const data = await response.json()
			eIAumByClientTypeDataList = data.EIAumByClientTypeDataList
			eIAumByClientTypeDataLabelList = data.EIAumByClientTypeDataLabelList
			eIAumByAssetCategoryDataList = data.EIAumByAssetCategoryDataList
			eIAumByAssetCategoryDataLabelList = data.EIAumByAssetCategoryDataLabelList
			eIAumByRegionDataList = data.EIAumByRegionDataList
			eIAumByRegionDataLabelList = data.EIAumByRegionDataLabelList
        }
	
		function getChartOptions(chartInstance)
		{
			if(chartInstance.id === 'external-insurance-aum-by-client-type-chart')
			{		
                return getDoughnutChartOptions();			
			}
			
			else if(chartInstance.id === 'external-insurance-aum-by-asset-category-chart')
			{
				return getDoughnutChartOptions();
			}

            else if(chartInstance.id === 'external-insurance-aum-by-region-chart')
			{
				return getDoughnutChartOptions();
			}
		}

        function getDoughnutChartOptions(){
            return {
                responsive: true,
                maintainAspectRatio: false,
                elements: { point: { radius: 3 } }, 
                plugins: {
                    legend: { position: 'bottom', labels: { generateLabels: function (theChart) { const data = theChart.data; if (data.labels.length && data.datasets.length) { return data.labels.map(function (label, i) { const meta = theChart.getDatasetMeta(0); const dataSet = data.datasets[0]; return { text: label + ' ' + dataSet.data[i] + '%', fillStyle: chartColors[i], strokeStyle: chartColors[i], lineWidth: 1, hidden: isNaN(dataSet.data[i]) || meta.data[i].hidden, index: i }; }); } return []; } } },
                    tooltip: { callbacks: { label: function (context) { return context.label + ': ' + context.parsed + '%'; } } },
                    datalabels: { display: false, align: function (context) { var value = context.dataset.data[context.dataIndex]; return value > 0 ? 'end' : 'start'; }, anchor: function (context) { var value = context.dataset.data[context.dataIndex]; return value > 0 ? 'end' : 'start'; }, padding: 5, color: function (context) { return context.dataset.borderColor; }, labels: { title: { font: { weight: 'bold' } } } }
                }
            }
        }
	}
}

export default cmpInsuranceSolutionsAumCharts;